import { render, staticRenderFns } from "./recharge-transfer.vue?vue&type=template&id=474769db&scoped=true&"
import script from "./recharge-transfer.vue?vue&type=script&lang=js&"
export * from "./recharge-transfer.vue?vue&type=script&lang=js&"
import style0 from "./recharge-transfer.vue?vue&type=style&index=0&id=474769db&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474769db",
  null
  
)

export default component.exports